import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be27b4d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ガウス整数のユークリッド互除法", -1))
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 入力 ", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "math" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"50px"} }, ",", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "math" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"50px"} }, ",", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"20px"} }, ",", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 計算 ", -1))
const _hoisted_12 = { class: "math" }
const _hoisted_13 = { class: "mtable" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"50px"} }, ",")
], -1))
const _hoisted_15 = {
  class: "mtd",
  style: {"text-align":"left"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 最大公約数 ", -1))
const _hoisted_17 = { class: "math" }
const _hoisted_18 = { style: {"margin-left":"20px"} }
const _hoisted_19 = { style: {"margin-left":"20px"} }
const _hoisted_20 = { style: {"margin-left":"20px"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " 1次不定方程式の解 ", -1))
const _hoisted_22 = { class: "math" }
const _hoisted_23 = { class: "mtable" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, " = ", -1))
const _hoisted_27 = {
  class: "mtd",
  style: {"text-align":"left"}
}
const _hoisted_28 = ["onMouseover"]
const _hoisted_29 = { class: "mtd" }
const _hoisted_30 = ["onMouseover"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mtd" }, " = ", -1))
const _hoisted_32 = ["onMouseover"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_34 = { class: "math" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "商 q"),
  /*#__PURE__*/_createElementVNode("th", null, "余り r"),
  /*#__PURE__*/_createElementVNode("th", null, "N(r)"),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_36 = { class: "math" }
const _hoisted_37 = { class: "math" }
const _hoisted_38 = { class: "math" }
const _hoisted_39 = ["onClick"]

import { ref } from 'vue';
import { Gauss, mkQlist, qlistI } from '@/composable/lib.ts';

interface CalcI {
  z: Gauss;
  w: Gauss;
  q: Gauss;
  r: Gauss;
  zSty: string;
  wSty: string;
  rSty: string;
}
interface EqnI {
  start: boolean;
  a: Gauss;
  b: Gauss;
  x: Gauss;
  y: Gauss;
  x2: Gauss;
  q: Gauss;
  aSty: string;
  bSty: string;
  cSty: string;
  index: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GaussEuclid',
  setup(__props) {

const colorTable = [
  '#F00',
  '#FA0',
  '#080',
  '#00F',
  '#808'
]
const colorTableLen = colorTable.length;

const z0 = ref(Gauss.one);
const w0 = ref(Gauss.one);
const z = ref(Gauss.one);
const w = ref(Gauss.one);
const high = ref(-Infinity);

const history = ref(new Array<CalcI>());

const eqn = ref(new Array<EqnI>());
const zSty = ref('');

const input = ref(true);
const message = ref('');
const calc = function(){
  if(z0.value.error || w0.value.error){
    message.value = '実部、虚部とも整数を入力してください。';
    input.value = true;
  }else if(z0.value.isZero || w0.value.isZero){
    message.value = 'z, wは0以外にしてください。';
    input.value = true;    
  }else{
    message.value = '';
    input.value = false;
    z.value = z0.value.copy();
    w.value = w0.value.copy();
    history.value.splice(0);
    eqn.value.splice(0);
    divide();
  }
}

const qlist = ref(new Array<qlistI>());
const divide = function(){
  qlist.value = mkQlist(z.value,w.value,false);
}

const choose = function(entry: qlistI){
  const i = history.value.length;
  history.value.push({
    z: z.value,
    w: w.value,
    q: entry.q,
    r: entry.r,
    zSty: 'color:' + colorTable[i % colorTableLen],
    wSty: 'color:' + colorTable[(i+1) % colorTableLen],
    rSty: 'color:' + colorTable[(i+2) % colorTableLen],
  });
  z.value = w.value;
  w.value = entry.r;
  if(w.value.isZero){
    mkEqn();
  }else{
    divide();
  }
}

const mkEqn = function(){
  if(history.value.length < 2){
    return;
  }
  zSty.value = 'color:' + colorTable[history.value.length % colorTableLen];
  eqn.value.splice(0);
  let x = Gauss.zero;
  let y = Gauss.one;
  let x2 = Gauss.zero;
  for(let k=history.value.length-2; k>=0; k--){
    const entry = history.value[k];
    x2 = x;
    x = y;
    y = x2.sub(entry.q.mul(x));
    eqn.value.push({
      start: k == history.value.length-2,
      a: entry.z.copy(),
      b: entry.w.copy(),
      x: x.copy(),
      y: y.copy(),
      x2: x2.copy(),
      q: entry.q.copy(),
      aSty: entry.zSty,
      bSty: entry.wSty,
      cSty: 'border-bottom: dashed 2px ' + colorTable[ (k+2) % colorTableLen ],
      index: k
    });
  }
}

const rotate = function(){
  z.value = z.value.mul(Gauss.i);
  for(const entry of eqn.value){
    entry.x = entry.x.mul(Gauss.i);
    entry.x2 = entry.x2.mul(Gauss.i);
    entry.y = entry.y.mul(Gauss.i);
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (input.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(" 実部、虚部とも整数を入力してください。 "),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createTextVNode(" z = "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((z0.value.r) = $event)),
                  class: _normalizeClass({error:z0.value.Rerror}),
                  type: "text"
                }, null, 2), [
                  [
                    _vModelText,
                    z0.value.r,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createTextVNode(" + "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((z0.value.i) = $event)),
                  class: _normalizeClass({error:z0.value.Ierror}),
                  type: "text"
                }, null, 2), [
                  [
                    _vModelText,
                    z0.value.i,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createTextVNode("i ")
              ]),
              _createElementVNode("li", null, [
                _createTextVNode(" w = "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((w0.value.r) = $event)),
                  class: _normalizeClass({error:w0.value.Rerror}),
                  type: "text"
                }, null, 2), [
                  [
                    _vModelText,
                    w0.value.r,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createTextVNode(" + "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((w0.value.i) = $event)),
                  class: _normalizeClass({error:w0.value.Ierror}),
                  type: "text"
                }, null, 2), [
                  [
                    _vModelText,
                    w0.value.i,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createTextVNode("i ")
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(" z = " + _toDisplayString(z0.value.txt), 1),
              _hoisted_6,
              _createTextVNode(" w = " + _toDisplayString(w0.value.txt), 1)
            ]),
            _createElementVNode("button", { onClick: calc }, "計算"),
            _createTextVNode(" " + _toDisplayString(message.value), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" z = " + _toDisplayString(z0.value.txt), 1),
              _hoisted_9,
              _createTextVNode(" w = " + _toDisplayString(w0.value.txt), 1),
              _hoisted_10,
              _createTextVNode(" N(w) = " + _toDisplayString(w0.value.norm), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (input.value = true))
            }, "値の変更")
          ])),
      (! input.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("table", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(history.value, (entry, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", {
                      class: _normalizeClass(["mtd", {highlight: high.value == index}])
                    }, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(entry.zSty)
                      }, _toDisplayString(entry.z.txt), 5)
                    ], 2),
                    _createElementVNode("td", {
                      class: _normalizeClass(["mtd", {highlight: high.value == index}])
                    }, " = ", 2),
                    _createElementVNode("td", {
                      class: _normalizeClass(["mtd", {highlight: high.value == index}])
                    }, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(entry.wSty)
                      }, _toDisplayString(entry.w.fencedTxt), 5)
                    ], 2),
                    _createElementVNode("td", {
                      class: _normalizeClass(["mtd", {highlight: high.value == index}])
                    }, " × ", 2),
                    _createElementVNode("td", {
                      class: _normalizeClass(["mtd", {highlight: high.value == index}])
                    }, _toDisplayString(entry.q.fencedTxt), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["mtd", {highlight: high.value == index}])
                    }, " + ", 2),
                    _createElementVNode("td", {
                      class: _normalizeClass(["mtd", {highlight: high.value == index}])
                    }, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(entry.rSty)
                      }, _toDisplayString(entry.r.fencedTxt), 5)
                    ], 2),
                    _hoisted_14,
                    _createElementVNode("td", _hoisted_15, " N(r) = " + _toDisplayString(entry.r.norm), 1)
                  ]))
                }), 128))
              ])
            ]),
            (w.value.isZero)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_16,
                  _createElementVNode("div", null, _toDisplayString(z0.value.txt) + " と " + _toDisplayString(w0.value.txt) + " の最大公約数は、 ", 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(zSty.value)
                    }, _toDisplayString(z.value.txt), 5),
                    _createTextVNode(", "),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(z.value.mul(_unref(Gauss).i).txt), 1),
                    _createTextVNode(", "),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(z.value.mul(_unref(Gauss).minusOne).txt), 1),
                    _createTextVNode(", "),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(z.value.mul(_unref(Gauss).minusI).txt), 1),
                    _createTextVNode(". "),
                    _createElementVNode("button", {
                      style: {"margin-left":"50px","font-size":"24px"},
                      onClick: rotate
                    }, " i 倍")
                  ]),
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("table", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eqn.value, (entry, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (! entry.start)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                                _hoisted_25,
                                _hoisted_26,
                                _createElementVNode("td", _hoisted_27, [
                                  _createElementVNode("span", {
                                    style: _normalizeStyle(entry.bSty)
                                  }, _toDisplayString(entry.b.fencedTxt), 5),
                                  _createTextVNode(" × " + _toDisplayString(entry.x2.fencedTxt) + " + ", 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass({highlight: high.value == entry.index}),
                                    style: _normalizeStyle(entry.cSty),
                                    onMouseover: ($event: any) => (high.value = entry.index),
                                    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (high.value = -Infinity))
                                  }, [
                                    _createTextVNode(" { "),
                                    _createElementVNode("span", {
                                      style: _normalizeStyle(entry.aSty)
                                    }, _toDisplayString(entry.a.fencedTxt), 5),
                                    _createTextVNode(" - "),
                                    _createElementVNode("span", {
                                      style: _normalizeStyle(entry.bSty)
                                    }, _toDisplayString(entry.b.fencedTxt), 5),
                                    _createTextVNode(" × " + _toDisplayString(entry.q.fencedTxt) + " } ", 1)
                                  ], 46, _hoisted_28),
                                  _createTextVNode(" × " + _toDisplayString(entry.x.fencedTxt), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_29, [
                              (entry.start)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    style: _normalizeStyle(zSty.value),
                                    class: _normalizeClass({highlight: high.value == entry.index}),
                                    onMouseover: ($event: any) => (high.value = entry.index),
                                    onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (high.value = -Infinity))
                                  }, _toDisplayString(z.value.txt), 47, _hoisted_30))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_31,
                            _createElementVNode("td", {
                              class: _normalizeClass(["mtd", {highlight: entry.start && high.value == entry.index}]),
                              style: {"text-align":"left"}
                            }, [
                              _createElementVNode("span", {
                                style: _normalizeStyle(entry.aSty)
                              }, _toDisplayString(entry.a.fencedTxt), 5),
                              _createTextVNode(" × " + _toDisplayString(entry.x.fencedTxt) + " + ", 1),
                              _createElementVNode("span", {
                                class: _normalizeClass({highlight: high.value == entry.index-1 && entry.index > 0}),
                                style: _normalizeStyle(entry.bSty),
                                onMouseover: ($event: any) => (high.value = entry.index-1),
                                onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (high.value = -Infinity))
                              }, _toDisplayString(entry.b.fencedTxt), 47, _hoisted_32),
                              _createTextVNode(" × " + _toDisplayString(entry.y.fencedTxt), 1)
                            ], 2)
                          ])
                        ], 64))
                      }), 128))
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, _toDisplayString(z.value.txt) + " = " + _toDisplayString(w.value.fencedTxt) + " × q + r ", 1),
                  _createElementVNode("table", null, [
                    _hoisted_35,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qlist.value, (entry, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_36, _toDisplayString(entry.q.txt), 1),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(entry.r.txt), 1),
                        _createElementVNode("td", _hoisted_38, _toDisplayString(entry.r.norm), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (choose(entry))
                          }, "次を計算", 8, _hoisted_39)
                        ])
                      ]))
                    }), 128))
                  ])
                ], 64))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})